import {useRouter} from 'next/router';
import {useEffect} from 'react';

export const useScrollRestoration = () => {
  const router = useRouter();
  useEffect(() => {
    const saveScrollPosition = () => {
      const scrollPosition = window.scrollY;
      sessionStorage.setItem('scrollPosition', scrollPosition.toString());
    };

    const restoreScrollPosition = () => {
      const scrollPosition = sessionStorage.getItem('scrollPosition');
      if (scrollPosition) {
        window.scrollTo(0, Number.parseInt(scrollPosition, 10));
        sessionStorage.removeItem('scrollPosition');
      }
    };

    restoreScrollPosition();

    const handleRouteChangeStart = () => {
      saveScrollPosition();
    };

    router.events.on('routeChangeStart', handleRouteChangeStart);

    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart);
    };
  }, []);
};
